// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Kd5VvjN2aJwjOaHDZUgHH"};